module.exports = __webpack_public_path__ + "static/Video-18274e1eb7306739644d3126d389597a.jpg";